const matchHeight = () => {
    const sections = document.querySelectorAll("[data-match-height]");

    // go through each data-match-height section to find target children to match height of
    for (let section of sections) {
        const childrenSelector = section.getAttribute("data-match-height");
        const childItems = section.querySelectorAll(childrenSelector);
        let tallestHeight = 0;

        // loop through child items to match height of
        for (let child of childItems) {
            const childNodes = child.children;
            let totalChildrenHeight = 0;

            // get total height of the target (section > matchHeightChild > children)
            for (let children of childNodes) {
                totalChildrenHeight =
                    totalChildrenHeight + children.clientHeight;
            }

            // set tallest height to tallest matchHeightChild child
            if (totalChildrenHeight > tallestHeight) {
                tallestHeight = totalChildrenHeight;
            }
        }

        // set calcualted tallest height on each child selector
        for (let child of childItems) {
            child.style.height = `${tallestHeight}px`;
        }
    }

    requestAnimationFrame(matchHeight);
};

matchHeight();
